// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39Q8p","fullView":"styles_fullView__1rH7T"};